import ViewKPIChartTable from './ViewKPIChartTable';
import ViewInventoryAnalysis from './ViewInventoryAnalysis';

export const KPIChartTable = ViewKPIChartTable;
export const IventoryAnalysis = ViewInventoryAnalysis;

export default {
    'kpi-chart-table': ViewKPIChartTable,
    'inventory-analysis': ViewInventoryAnalysis
};